export default __webpack_public_path__ + "static/media/xplenty.69cc97de.svg";